import { HeaderGridRow } from 'ui/indexPages/tables/grid';
import { Column } from 'ui/indexPages/tables/header/constants';
import { useSortingContext } from 'utils/contexts/sorting';
import { TableHeaderButton } from '../../campaignIndex/components/TableHeaderButton';
import { USAGE_TABLE_COLUMNS } from '../constants';
import { getUsageGrid } from '../utils';

type Props = {
  columns?: Column[];
};

export const UsageTableHeader = ({ columns = USAGE_TABLE_COLUMNS }: Props) => {
  const { sortBy, sortDirection, setSortBy, setSortDirection } = useSortingContext();

  return (
    <HeaderGridRow gridLayout={getUsageGrid()}>
      {columns.map((column) => (
        <TableHeaderButton
          key={column.id}
          sortDirection={sortDirection}
          onSortByChange={setSortBy}
          onSortDirectionChange={setSortDirection}
          isActiveSortColumn={column.id === sortBy}
          isSortable={!!column.isSortable}
          {...column}
        />
      ))}
    </HeaderGridRow>
  );
};
